import { ScrollArea } from '@/components/ui/scroll-area';

function lineText(line) {
  if (line == null) return '';
  if (typeof line === 'string') return line;
  if (typeof line === 'object') {
    return (
      line.text
      || line.message
      || line.MESSAGE
      || line.msg
      || JSON.stringify(line)
    );
  }
  return String(line);
}

export default function SapJobLogPanel({ lines, emptyMessage }) {
  const rows = Array.isArray(lines) ? lines : [];
  if (rows.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">{emptyMessage || 'No log lines.'}</p>
    );
  }

  return (
    <ScrollArea className="h-64 w-full rounded-md border bg-muted/30 p-3">
      <pre className="text-xs font-mono whitespace-pre-wrap break-words" data-testid="sap-job-log-panel">
        {rows.map((line, idx) => (
          <div key={`log-${idx}`}>{lineText(line)}</div>
        ))}
      </pre>
    </ScrollArea>
  );
}
